import { c as _c } from "react/compiler-runtime";
import type { OrgTeams } from '@/types/github';
import { useQuery } from '@tanstack/react-query';
import { fetchOrgTeams, orgTeamsQueryKey } from './query-keys';

/**
 * Fetches the GitHub teams of an organization for the reviewer picker.
 * Returns an empty list when the owner is a user account or when team
 * visibility is unavailable (the API route maps 403/404 to []).
 */
export function useOrgTeams(org, options) {
  const $ = _c(9);
  const areParamsValid = Boolean(org);
  let t0;
  if ($[0] !== areParamsValid || $[1] !== org) {
    t0 = areParamsValid ? orgTeamsQueryKey(org) : ["org-teams", "invalid"];
    $[0] = areParamsValid;
    $[1] = org;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== org) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchOrgTeams(org, signal);
    };
    $[3] = org;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = areParamsValid && (options?.enabled ?? true);
  let t3;
  if ($[5] !== t0 || $[6] !== t1 || $[7] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      refetchOnWindowFocus: false,
      staleTime: 21600000
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return useQuery(t3);
}